






















import { Vue, Component, Watch } from 'vue-property-decorator';

@Component
export default class Emailopen extends Vue {
  openemail: boolean = false;

  btnenvelope() {
    this.open();
  }
  btnopen() {
    this.open();
  }
  btnreset() {
    this.close();
  }

  open() {
    this.openemail = true;
    // (this.$refs.envelope as any).addClass('open').removeClass('close');
  }
  close() {
    this.openemail = false;
    // (this.$refs.envelope as any).addClass('close').removeClass('open');
  }
}
